// extracted by mini-css-extract-plugin
export var card = "_l0-5";
export var cardSelected = "_l0-4";
export var image = "_l0-3";
export var modal = "_l0-0";
export var modalContent = "_l0-1";
export var table = "_l0-2";